import NoData from "@/components/NoData";
import LtdLoading from "@/components/LichThiDauFull/LtdLoading";
import ContinentFilter from "./ContinentFilter";
import FifaRankingTable from "./FifaRankingTable";
import useBangXepHangFifa from "./useBangXepHangFifa";
import "@/components/LichThiDauFull/index.css";
import "@/components/BangXepHangByLeague/index.css";

/**
 * @param {object} props
 * @param {1|2} props.type 1=Nam, 2=Nữ
 * @param {string} [props.continent] data-league continent slug (ẩn filter nếu có)
 */
export default function BangXepHangFifa({ type, continent }) {
  const {
    themeStyle,
    hasFixedContinent,
    continents,
    activeContinent,
    setActiveContinent,
    rows,
    total,
    visibleItems,
    loading,
    failed,
    loadMore,
    canLoadMore,
  } = useBangXepHangFifa(type, continent);

  return (
    <div
      className="kbv-bxh kbv-ltd-full flex flex-col gap-2 bg-[var(--theme-bg)] text-[var(--theme-text)]"
      style={themeStyle}
    >
      {!hasFixedContinent ? (
        <ContinentFilter
          continents={continents}
          activeSlug={activeContinent}
          onSelect={setActiveContinent}
        />
      ) : null}

      {failed && !loading ? (
        <NoData message="Không có bảng xếp hạng FIFA" />
      ) : loading ? (
        <LtdLoading />
      ) : rows.length === 0 ? (
        <NoData message="Không có bảng xếp hạng FIFA" />
      ) : (
        <FifaRankingTable
          rows={rows}
          total={total}
          visibleItems={visibleItems}
          canLoadMore={canLoadMore}
          onLoadMore={loadMore}
        />
      )}
    </div>
  );
}
